import { TOUCH_ZOOM_DAMPENING, TOUCH_ZOOM_SENSIBILITY, TOUCH_ZOOM_SENSIBILITY_WEIGHT, ZOOM_DAMPENING_WEIGHT } from '@modules/tourdanji/src/Constants';

import { clamp } from '../..';
import { DoubleTouchBase, TouchData, ZoomOption } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { checkPinchDoubleTouch, getPinchDelta } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

let lastDistance: number = 0;
export const DoubleTouchPinchZoom: DoubleTouchBase & ZoomOption = {
  type: 'DoubleTouch',
  touchCount: 2,
  key: 'DoubleTouchPinch',
  name: 'DoubleTouchPinchZoom',
  option: {
    sensibility: TOUCH_ZOOM_SENSIBILITY,
    panningRatio: 0.2,
    freeMovement: false,
    inertia: 0.7,
    radiusDampening: TOUCH_ZOOM_DAMPENING,
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {
    lastDistance = 0;
  },
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  checkCondition(_camera: ZEDCamera, touchData: TouchData[]) {
    const t1 = touchData[0];
    const t2 = touchData[1];
    if (!t1 || !t2) return false;

    const distance = t1.getPinchSquaredDistance(t2);
    const diff = Math.abs(distance - lastDistance);
    if (diff < 2500) {
      return false;
    }
    lastDistance = distance;
    return checkPinchDoubleTouch(touchData);
  },

  onTouchStart(camera, touchData, _canvasProps) {
    const t1 = touchData[0];
    const t2 = touchData[1];
    if (!t1 || !t2) return false;

    camera.stopPlayingAnimation();
    lastDistance = t1.getPinchSquaredDistance(t2);

    return true;
  },

  onTouchMoved(camera: ZEDCamera, touchData: TouchData[], _canvasProps: InputCanvasProps) {
    const t0 = touchData[0];
    const t1 = touchData[1];
    if (!t0 || !t1) return;

    const currentRadius = camera.radius;
    const minRadius = camera.lowerRadiusLimit ?? 0;
    const maxRadius = camera.upperRadiusLimit ?? 1000;
    const baseDampening = Math.max(0, (currentRadius - minRadius) / (maxRadius - minRadius));
    const dampeningParam = DoubleTouchPinchZoom.option.radiusDampening * ZOOM_DAMPENING_WEIGHT;
    const dampeningFactor = DoubleTouchPinchZoom.option.radiusDampening === 0 
    ? 1 
    : Math.max(0.1, Math.pow(baseDampening, 2) * (1 - dampeningParam) + baseDampening * dampeningParam);

    const delta =
      clamp(getPinchDelta(t0, t1), -250, 250) * DoubleTouchPinchZoom.option.sensibility * TOUCH_ZOOM_SENSIBILITY_WEIGHT * dampeningFactor;
    const rScale = camera.getRadiusScale();
    const bScale = camera.getBetaScale();

    camera.inertia = DoubleTouchPinchZoom.option.inertia;
    camera.inertialRadiusOffset += delta * rScale;
    camera.inertialBetaOffset += delta * bScale;
    const offset = camera.computeZoomAdjustOffset(delta);
    camera.setTarget(camera.target.add(offset));

    return true;
  },

  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {
    lastDistance = 0;
  },
};
